export default "__VITE_ASSET__ea1b524d__"